import { Heading, Stack } from '@kinesis/bungle';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNow } from '@/hooks/use-now';
import { useGetDisclosuresQuery } from '@/api/disclosures';
import { useGetInventoryQuery } from '@/api/inventories';
import { Loading } from '@/components/loading';
import { Layout } from '@/components/layout';
import { DisclosuresList } from '@/components/disclosures-list';

// Disclosures landing for a community. Mirrors suit's `pages/disclose`:
// `<Layout><Stack space='medium'><Heading as='h4' size='small'>Disclosures
// </Heading> … <list/></Stack></Layout>` on the page background — no
// white card. Owns the RTK list query (per the component/page split —
// `@/api` only ever in pages); the store-less `DisclosuresList` carries
// the search + items. The 'New disclosure' button lives in the inventory
// toolbar via `pages/toolbar-disclosures`.
const Disclosures = () => {
  const inventoryId = useInventoryId();
  const now = useNow();
  const { data: disclosures, isLoading } = useGetDisclosuresQuery(inventoryId);
  // The legacy-GPC existence signal rides the inventory detail (village
  // resolves it there only); the synthetic list entry links to `pages/gpc`.
  const { data: inventory } = useGetInventoryQuery(inventoryId);

  return (
    <Layout>
      <Stack space='medium'>
        <Heading as='h4' size='small'>
          Disclosures
        </Heading>
        {isLoading ? (
          <Loading />
        ) : (
          <DisclosuresList
            disclosures={disclosures ?? []}
            inventoryId={inventoryId}
            now={now}
            legacyGpcExists={inventory?.legacyGpcExists ?? false}
          />
        )}
      </Stack>
    </Layout>
  );
};

export { Disclosures };
